import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface DocumentState {
  shouldRefetch: boolean;
}

const initialState: DocumentState = {
  shouldRefetch: false,
};

const documentSlice = createSlice({
  name: "document",
  initialState,
  reducers: {
    triggerRefetch: (state) => {
      state.shouldRefetch = true;
    },
    resetRefetch: (state) => {
      state.shouldRefetch = false;
    },
  },
});

export const { triggerRefetch, resetRefetch } = documentSlice.actions;

export default documentSlice.reducer;
